import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Button } from '@material-ui/core';
import { useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { useSaveWikiPermittingMutation, useUpdatePermittingMutation } from '../../../redux/rtkQuery/apiWikiPermittingSlice';
import { InputTextWithLabel } from '../../../molecules';
import { RootState } from '../../../redux/root';
import { setPermittingPristine, setSelectedJurisdiction } from '../../../redux/slices/wikiSlice';
import { objectKeysToSnakeCase } from '../../../utils';
import { WikiPermittingType } from '../../../api/jurisdiction';
import Files from './Files';
import OnlineSub from './OnlineSub';
import PackageEachSubmission from './PackageEachSubmission';
import CredentialsComponent from './CredentialsComponent';
import Documents from './Documents/Documents';
import PermittingLinkToPortal from './PermittingLinkToPortal';
import { useGetJurisdictionByIdQuery } from '../../../redux/rtkQuery/apiWikiSlice';

const Permitting = () => {
  const { selectedJurisdiction, permittingPristine } = useSelector((s: RootState) => s.wikiSlice);
  const [show, setShow] = useState<boolean>(false);
  const [errors, setErrors] = useState<any>({});
  const [param, setParam] = useState<any>();
  const [showSuccess, setShowSuccess] = useState<boolean>(false);
  const [saveWikiPermitting] = useSaveWikiPermittingMutation();
  const [updatePermitting] = useUpdatePermittingMutation();
  const { data: wikiDetails, isUninitialized, refetch } = useGetJurisdictionByIdQuery(param, { skip: param === undefined });
  const dispatch = useDispatch();
  // @ts-ignore
  const { wikiId } = useParams();

  useEffect(() => {
    return () => {
      dispatch(setPermittingPristine(true));
    };
  }, []);
  useEffect(() => {
    setParam({ id: wikiId });
    if (!isUninitialized) {
      refetch();
    }
  }, [wikiId, wikiDetails]);
  useEffect(() => {
    if (selectedJurisdiction) {
      if (!selectedJurisdiction.permitting) {
        const permitting: WikiPermittingType = {
          id: -1,
          files: 'none',
          onlineSub: 'none',
          portalLink: '',
          portalLinkDescription: '',
          isPackageSub: 'none',
          permitEmail: '',
          username: '',
          password: '',
        };
        const _juri = {
          ...selectedJurisdiction,
          permitting,
        };
        dispatch(setSelectedJurisdiction(_juri));
      }
    }
  }, [selectedJurisdiction]);

  const resetSuccess = () => {
    setShowSuccess(true);
    dispatch(setPermittingPristine(true));
    setTimeout(() => {
      setShowSuccess(false);
    }, 2000);
  };

  const onEmailChanged = e => {
    dispatch(setPermittingPristine(false));
    dispatch(
      setSelectedJurisdiction({
        ...selectedJurisdiction,
        permitting: {
          ...selectedJurisdiction.permitting,
          permitEmail: e.target.value,
        },
      }),
    );
  };
  const onSave = async () => {
    // validation
    setErrors({});
    let foundIssue = false;
    const { permitting } = selectedJurisdiction;
    // if (!permitting.portalLink) {
    //   setShow(true);
    //   foundIssue = true;
    // }

    // if (!!!permitting.permitEmail) {
    //   const _errors = { ...errors, permitEmail: { message: 'Permit Email is required' } };
    //   setErrors(_errors);
    //   foundIssue = true;
    // }
    if (permitting.permitEmail) {
      if (!/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(permitting.permitEmail)) {
        const _errors = { ...errors, permitEmail: { message: 'Invalid email format' } };
        setErrors(_errors);
        foundIssue = true;
      }
    }

    // if (!permitting.username) {
    //   const _errors = { ...errors, username: { message: 'Login is required' } };
    //   setErrors(_errors);
    //   foundIssue = true;
    // }

    // if (!permitting.password) {
    //   const _errors = { ...errors, password: { message: 'Password is required' } };
    //   setErrors(_errors);
    //   foundIssue = true;
    // }

    if (foundIssue) return;

    const permittingId = permitting.id;
    // update existing record
    if (permittingId !== -1) {
      const _res = await updatePermitting(objectKeysToSnakeCase(permitting));
      resetSuccess();
      return;
    }

    // save new record
    const result = await saveWikiPermitting(objectKeysToSnakeCase({ ...permitting, jurisdiction: wikiId }));
    const _permitting = {
      ...permitting,
      // @ts-ignore
      id: result.data.id,
    };
    const _selectedJuri = {
      ...selectedJurisdiction,
      permitting: _permitting,
    };

    dispatch(setSelectedJurisdiction(_selectedJuri));
    resetSuccess();
  };

  const showSave = () => {
    if (!selectedJurisdiction.permitting) {
      return true;
    }
    return selectedJurisdiction.permitting?.id === -1;
  };

  return (
    <>
      <Card>
        <SectionTitle>Permitting</SectionTitle>

        <ColumnsGrid>
          <SubSection>
            <SubTitle>Submission</SubTitle>
            <SubmissionGroups>
              <Files />
              <SubmissionRow>
                <OnlineSub />
                <PackageEachSubmission />
              </SubmissionRow>
            </SubmissionGroups>
          </SubSection>

          <SubSection>
            <SubTitle>Credentials</SubTitle>
            <PortalLinkRow>
              <PortalLinkLabel>Portal Link</PortalLinkLabel>
              <LinkCell>
                <PermittingLinkToPortal show={show} setShow={setShow} resetSuccess={resetSuccess} />
              </LinkCell>
            </PortalLinkRow>
            <CredentialsComponent errors={errors} />
            <form>
              <InputTextWithLabel
                name="permitEmail"
                error={errors?.permitEmail}
                label="Permit Email"
                value={selectedJurisdiction?.permitting?.permitEmail}
                onChange={onEmailChanged}
              />
            </form>
          </SubSection>
        </ColumnsGrid>

        <Footer>
          <SaveWrapper>
            {showSuccess && <Success>Saved</Success>}
            <Button color="primary" variant="contained" onClick={onSave} disabled={permittingPristine}>
              Save
            </Button>
          </SaveWrapper>
        </Footer>
      </Card>
      {false && <Documents />}
    </>
  );
};

export default Permitting;

const FONT_STACK = `'Segoe UI', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, Roboto, sans-serif, 'Apple Color Emoji',
    'Segoe UI Emoji', 'Segoe UI Symbol'`;

const Card = styled.div`
  background: var(--neutral-0);
  border: 1px solid var(--border);
  border-radius: 10px;
  box-shadow: var(--shadow-xs);
  padding: 24px;
  margin-bottom: 20px;
  box-sizing: border-box;
  font-family: ${FONT_STACK};
`;

const SectionTitle = styled.div`
  font-size: 1.125rem;
  font-weight: 700;
  color: var(--mainText);
  margin-bottom: 20px;
`;

const ColumnsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 32px;
  align-items: stretch;
`;

const SubSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: var(--neutral-50);
  min-width: 0;
  box-sizing: border-box;

  form {
    width: 100%;
  }
`;

const SubTitle = styled.div`
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--neutral-500);
`;

const SubmissionGroups = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  font-size: 0.875rem;
  color: var(--mainText);
`;

const SubmissionRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  align-items: stretch;

  > * {
    min-width: 0;
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const PortalLinkRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const PortalLinkLabel = styled.div`
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--mainText);
  white-space: nowrap;
`;

const LinkCell = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  font-size: 0.875rem;
  color: var(--mainText);
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid var(--border);

  button {
    min-width: 140px;
    height: 40px;
    border-radius: 8px;
    font-weight: 600;
    text-transform: none;
    font-size: 0.875rem;
    letter-spacing: 0.01em;
  }
`;

const SaveWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 16px;
`;

const Success = styled.div`
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--success-600);
`;
